import classnames from 'classnames';
import { Author as V3Author, AuthorProps } from '@stadionhq-v3/base-ui';
import styles from './author.module.scss';

export const Author = ({ classNames, onDark, ...props }: AuthorProps) => {
  const classes = classnames(
    [
      styles.author,
      styles.authorTokens,
      {
        [`${styles.onDark}`]: onDark,
      },
    ],
    classNames
  );

  return <V3Author classNames={[classes]} onDark={onDark} {...props} />;
};
